import React, { useEffect, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../../SectionTitle';

import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import OrderCard from '../../OrderCard';

// Styles
import styles from './index.module.sass';

import getData from '../../Queries/getData';
import postGlobal from '../../Queries/postGlobal';
import getGlobal from '../../Queries/getGlobal';
import getCookie from '../../Queries/getCookie';

export default function ConsultDataUS(props) {
  const { device, setSessionMessage } = props;
  const screenSize = device?.screenSize || 'desktop';
  const [data, setData] = useState({});
  const [copyIcon, setCopyIcon] = useState('content_copy');
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const { t } = useTranslation('personalDataUS');

  const digitalBrochureLink = `${process.env.REACT_APP_MY_DIGITAL_BROCHURE}/${data.usuarioOK}`;

  const fetchData = useCallback(async () => {
    const jsonBody = {
      accion: '',
      usuarioOK: getCookie('usuarioOk'),
    };
    const resp = await getData({ jsonBody });
    setData(resp);
    setSessionMessage(resp.mensaje);
  }, [setSessionMessage]);

  const getValidation = useCallback(async () => {
    const resp = await getGlobal({ tmbservice: 'getMail', jsonBody: { idioma: 0 } });
    const { validado = false } = resp;
    setValidated(validado);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
    getValidation();
  }, [fetchData, getValidation]);

  const resendMail = useCallback(async () => {
    setLoading(true);
    const resp = await postGlobal({ tmbservice: 'postReenviarMailConfirmacion', jsonBody: {} });
    const { typeMessage } = resp;
    setLoading(false);
    if (typeMessage === 'success') alert(t('resendSuccess'));
    else t('resendError');
  }, [t]);

  function copyBrochureLink() {
    navigator.clipboard
      .writeText(digitalBrochureLink)
      .then(() => {
        setCopyIcon('done');
        setTimeout(() => {
          setCopyIcon('content_copy');
        }, '3000');
      })
      .catch((err) => {
        console.error('Error in copying text: ', err);
      });
  }

  return (
    <div className={`${styles.consult} ${styles[screenSize]}`}>
      <SectionTitle title={t('captureGold')} subtitle={t('captureBlue')} />
      <div className={screenSize === 'desktop' ? styles.container : styles.containerMobile}>
        <div className={styles.myDigitalCatalog}>
          <span className={styles.myDigitalText}>{t('mayDigitalText')}: </span>
          <a
            href={digitalBrochureLink}
            className={styles.myDigitalLink}
            target='_blank'
            rel='noreferrer'>
            {digitalBrochureLink}
          </a>
          <div className={styles.copyIcon}>
            <i className={`material-icons ${styles.icon}`} onClick={copyBrochureLink}>
              {copyIcon}
            </i>
          </div>
          {copyIcon === 'done' && <div className={styles.copiedText}>{t('linkCopied')}</div>}
        </div>
        <OrderCard>
          <div className={styles.orderDet}>
            <div className={styles.cardText}>
              <div className={styles.textIcon}>
                <i className={`material-icons-outlined ${styles.icon}`}>account_box </i>
                <label className={styles.iconText}>{t('PersonalData')}</label>
              </div>
            </div>
            <div className={styles.item} name='RowKit'>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('kit')}</label>
                </div>
                <label className={styles.labelGray}>{data.usuarioOK}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('name')}</label>
                </div>
                <label className={styles.labelGray}>{data.nombre + ' ' + data.paterno}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('dateOfBirth')}</label>{' '}
                </div>
                <label className={styles.labelGray}>{data.fechaNac}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('sexo')}</label>{' '}
                </div>
                <label className={styles.labelGray}>{data.sexo}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('ssn')}</label>
                </div>
                <label className={styles.labelGray}>{data.rfc}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('sponsor')}</label>
                </div>
                <label className={styles.labelGray}>
                  {data.kitPatrocinadora + ' ' + data.nombrePatrocinadora}
                </label>
              </div>
            </div>
          </div>
        </OrderCard>
        <OrderCard>
          <div className={styles.orderDet}>
            <div className={styles.cardText}>
              <div className={styles.textIcon}>
                <i className={`material-icons-outlined ${styles.icon}`}>home</i>
                <label className={styles.iconText}>{t('home')}</label>
              </div>
            </div>
            <div className={styles.item} name='RowKit'>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('street')}</label>
                </div>
                <label className={styles.labelGray}>
                  {data?.calle} {data?.entreCalle}
                </label>
              </div>

              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('cp')}</label>
                </div>
                <label className={styles.labelGray}>{data.cp}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('city')}</label>
                </div>
                <label className={styles.labelGray}>{data.ciudad}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('state')}</label>
                </div>
                <label className={styles.labelGray}>{data.estadoDescri}</label>
              </div>
            </div>
          </div>
        </OrderCard>
        <OrderCard>
          <div className={styles.orderDet}>
            <div className={styles.cardText}>
              <div className={styles.textIcon}>
                <i className={`material-icons-outlined ${styles.icon}`}>contact_phone</i>
                <label className={styles.iconText}>{t('contact')}</label>
              </div>
            </div>
            <div className={styles.item} name='RowKit'>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('tel2')}</label>
                </div>
                <label className={styles.labelGray}>{data.celular}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('mail')}</label>
                </div>
                <label className={styles.labelGray}>{data.email}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('validatedText')}</label>
                </div>
                <label className={styles.labelGray}>
                  {(validated && t('validated')) || t('noValidated')}
                </label>
              </div>
            </div>
          </div>
        </OrderCard>
        {!validated && (
          <div className={styles.resendButton}>
            <div className={styles.resendText}>{t('resendText')}</div>
            <Button
              type='submit'
              variant='contained'
              size='large'
              color='primary'
              className={styles.button}
              onClick={() => {
                resendMail();
              }}>
              {(loading && <CircularProgress className={styles.circularProgress} />) || (
                <span className={styles.buttonText}>{t('resendButton')}</span>
              )}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
